import Api from "./Api";

const endpoint = "/changelog";
export default {
    get() {
        return Api.fetchData(endpoint);
    }
};
